module.exports = __webpack_public_path__ + "static/img/jgwbimcas.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/jgwbimcas.png
// module id = fyC6
// module chunks = 13